<template>
  <div class="charts" style="width: 100%; height: 100%"></div>
</template>
<script>
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/radar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import defaultsdeep from 'lodash.defaultsdeep'
export default {
  name: 'RadarCharts',
  props: {
    data: Array,
    legendData: {
      type: Array,
      default() {
        return []
      }
    },
    radarData: {
      type: Array,
      default() {
        return []
      }
    },
    option: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  watch: {
    data() {
      this.createCharts()
    }
  },
  mounted() {
    this.createCharts()
  },
  methods: {
    createCharts() {
      if (!this.Chart) this.Chart = echarts.init(this.$el)
      this.Chart.setOption(
        defaultsdeep(
          {},
          {
            tooltip: {
              trigger: 'item',
              confine: true
            },
            legend: {
              bottom: -5,
              data: this.legendData,
              itemGap: 65,
              textStyle: {
                color: '#666',
                fontSize: 14
              },
              selectedMode: 'multiple',
              itemWidth: 6,
              itemHeight: 6
            },
            radar: {
              indicator: this.radarData,
              center: ['50%', '50%'],
              radius: '60%',
              shape: 'circle',
              splitNumber: 5,
              name: {
                color: '#666',
                fontSize: 14
              },
              splitLine: {
                lineStyle: {
                  color: '#E9E9E9'
                }
              },
              splitArea: {
                show: false
              },
              axisLine: {
                lineStyle: {
                  color: '#E9E9E9'
                }
              }
            },
            series: this.data
          },
          this.option
        )
      )
    }
  }
}
</script>
